import { render, staticRenderFns } from "./Extractos.vue?vue&type=template&id=3d85dae8"
import script from "./Extractos.vue?vue&type=script&lang=js"
export * from "./Extractos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports